import { LAB_EVALUATIONS } from "./lab-evaluations.generated.ts";

export { LAB_EVALUATIONS };

/**
 * A lab's state (openspec change `model-picking`, D17, the user's middle ground of 2026-11-02):
 * operators see `blocked | untested | tested`; tenant admins `untested | tested` (a blocked lab is
 * never listed to them). Evaluation decides only the badge and the warning, never whether a
 * lab may be used: no stage refuses an untested lab.
 */
export const LAB_STATES = ["blocked", "untested", "tested"] as const;
export type LabState = (typeof LAB_STATES)[number];

/** A recorded evaluation of a lab: the badge's date and catalogue version. */
export interface LabEvaluation {
  /** The recording's date (`YYYY-MM-DD`). */
  readonly date: string;
  /** `MODEL_CATALOGUE_VERSION` at the recording. */
  readonly catalogueVersion: string;
}

/** The recorded evaluation of a lab, if any. */
export function labEvaluation(lab: string): LabEvaluation | undefined {
  return Object.hasOwn(LAB_EVALUATIONS, lab) ? LAB_EVALUATIONS[lab] : undefined;
}

/** A lab's state on an instance whose list (the operator's ceiling) is `instanceLabs`. */
export function labState(lab: string, instanceLabs: readonly string[]): LabState {
  if (!instanceLabs.includes(lab)) {
    return "blocked";
  }
  return labEvaluation(lab) ? "tested" : "untested";
}

/** The untested-lab warning (D4, D17), EN and FR, shown before a tenant admin opts in. */
export const UNTESTED_LAB_WARNING = {
  en: "Not tested by ESI: answer quality, tool use and citations may be less reliable",
  fr: "Non testé par ESI : la qualité des réponses, l'usage des outils et les citations peuvent être moins fiables",
} as const;
